import { render, staticRenderFns } from "./wisdomClassMain.vue?vue&type=template&id=f35ed7f2&scoped=true"
import script from "./wisdomClassMain.vue?vue&type=script&lang=js"
export * from "./wisdomClassMain.vue?vue&type=script&lang=js"
import style0 from "./wisdomClassMain.vue?vue&type=style&index=0&id=f35ed7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35ed7f2",
  null
  
)

export default component.exports